<template>
    <div>
        <div class="hidden duration-700 ease-in-out" data-carousel-item>
            <img src="/docs/images/carousel/carousel-1.svg" class="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="Carousel slide">
        </div>
        <div class="hidden duration-700 ease-in-out" data-carousel-item>
            <img src="/docs/images/carousel/carousel-2.svg" class="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2" alt="Carousel slide">
        </div>
    </div>
</template>

<style>
.fill-blue-600 {
    fill: #1c64f2;
}
</style>

<script>
import CalendarDay from "@/Pages/ParentPortal/Home/CalendarDay";
import SingleDay from "@/Pages/ParentPortal/Home/SingleDay";

export default {
    props: ["weeks", "searchForm", "index", "daysImport", "graderanges", "mealTypeImport", "excludeDays", "isMenuPlanner", "users", "is_loading", "viewPage"],
    components: {
        CalendarDay,
        SingleDay,
    },
    computed: {
        showImport: function () {
            if (this.weeks.days[6].is_past) {
                if (!this.weeks.menuCycle) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    },
    data() {
        return {
            isShowImportData: false,
            log: console.log
        }
    },
    methods: {
        loadCalendar() {
            this.$emit('loadCalendar');
        },
        loadAlreadyAddedCartData() {
            this.$emit('loadAlreadyAddedCartData');
        },
        loadExcludedDateDataOnLoad(site, guide_line_id) {
            this.$emit('loadExcludedDateDataOnLoad', site, guide_line_id);
        },
        copyData(id) {
            this.$emit('copyData', id);
        }

    }
};
</script>
